var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 20,
    fill: "#F7DF1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 120C67.5 132.5 60 137.5 50 137.5C40.5 137.5 35 132 32.5 125L42.5 120C44.5 124 46.5 127.5 50 127.5C53.5 127.5 55.5 125.5 55.5 120V85H67.5V120Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90 138C78.5 138 70.5 131.5 67.5 123L77.5 118C80 123 84 126 90 126C95 126 98 123.5 98 120C98 116 95 114.5 89.5 112L86.5 110.5C78.5 107 73.5 102.5 73.5 94C73.5 86.5 79.5 81 89.5 81C96.5 81 102 83.5 105.5 90.5L96 95.5C94 92 91.5 90.5 89.5 90.5C87.5 90.5 86 92 86 94C86 97.5 87.5 98.5 92.5 100.5L95.5 102C105 106 110 110.5 110 119C110 128.5 102 138 90 138Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.291306e7f4a13b7023bf523077e41f61.svg";
export { ForwardRef as ReactComponent };